<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M25.666 8.667a1 1 0 00-1 1V16H8.678l3.793-3.793a1 1 0 00-1.414-1.414l-5.382 5.382a1.167 1.167 0 000 1.65l5.382 5.382a1 1 0 101.414-1.414L8.678 18h16.987a1 1 0 001.001-1V9.666a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsLeftDown'
}
</script>
